<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title"> {{ $t('report_management.circular') + ' ' + $t('report_management.publication') + ' ' + $t('globalTrans.report') }} </h4>
      </template>
      <template v-slot:body>
        <b-row>
          <b-col xs="12" sm="12" md="6" lg="6" xl="6">
            <b-form-group
            class="row"
            label-cols-sm="3"
            label-for="fiscal_year_id"
            >
            <template v-slot:label>
              {{$t('globalTrans.fiscal_year')}}
            </template>
            <b-form-select
            plain
            v-model="search.fiscal_year_id"
            :options="fiscalYearList"
            id="fiscal_year_id"
            >
            <template v-slot:first>
              <b-form-select-option :value="0">{{$t('globalTrans.all')}}</b-form-select-option>
            </template>
              </b-form-select>
            </b-form-group>
          </b-col>
            <b-col lg="6" sm="12">
              <b-form-group
                  class="row"
                  label-cols-sm="3"
                  label-for="circular_id"
                  >
                  <template v-slot:label>
                      {{ $t('trainer_trainee.circular_memo_no') }}
                  </template>
                  <b-form-select
                      plain
                      v-model="search.circular_id"
                      id="circular_id"
                      :options="circularMemoList"
                  >
                  <template v-slot:first>
                      <b-form-select-option :value="0">{{$t('globalTrans.all')}}</b-form-select-option>
                  </template>
                  </b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="6" sm="12">
              <b-form-group
                  class="row"
                  label-cols-sm="3"
                  label-for="training_title_id"
                  >
                  <template v-slot:label>
                      {{ $t('trainer_trainee.training_title') }}
                  </template>
                  <b-form-select
                      plain
                      v-model="search.training_title_id"
                      id="training_title_id"
                      :options="trainingTitleList"
                  >
                  <template v-slot:first>
                      <b-form-select-option :value="0">{{$t('globalTrans.all')}}</b-form-select-option>
                  </template>
                  </b-form-select>
              </b-form-group>
            </b-col>
          <b-col xs="12" sm="12" md="6" lg="6" xl="6">
            <b-form-group
              class="row"
              label-cols-sm="3"
              label-for="organiation_id"
            >
              <template v-slot:label>
                {{$t('globalTrans.organization')}}
              </template>
              <b-form-select
                plain
                v-model="search.org_id"
                :options="orgList"
                id="organiation_id"
              >
                <template v-slot:first>
                  <b-form-select-option :value="0">{{$t('globalTrans.all')}}</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col lg="12" md="6" sm="12">
            <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search') }}</b-button>
          </b-col>
        </b-row>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
            <template v-slot:body>
                <b-row v-if="loaded">
                   <b-col xs="12" sm="12" md="12" class="mt-4 text-right">
                    <b-button-group class="pr-2">
                      <b-button @click="pdfExport" variant="success">{{  $t('globalTrans.export_pdf') }}</b-button>
                      <b-button variant="warning">
                        <export-excel
                          :data="excelData"
                          :title="headerValue"
                          worksheet="Report Sheet"
                          name="circular-publication-report.xls">
                          {{ $t('globalTrans.export_excel') }}
                        </export-excel>
                      </b-button>
                    </b-button-group>
                  </b-col>
                  <b-col xs="12" sm="12" md="12" class="text-center mt-3">
                    <b-img :src="`${ reportHeadData.reportHeadColumn[2].image }`" fluid alt="BD Image" style="width:7%;border-radius:50%;"></b-img>
                  </b-col>
                    <b-col xs="12" sm="12" md="3" class="text-right mt-3">
                        <b-img :src="`${ reportHeadData.reportHeadColumn[0].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
                    </b-col>
                    <b-col xs="12" sm="12" md="6" class="text-center mt-2">
                      <h3 class="text-bold">{{ $t('production_store.govt_info') }}</h3>
                      <h4 class="text-center text-dark">{{ reportHeadData.orgName }}</h4>
                      <span class="text-center text-dark">{{ reportHeadData.heading }}</span><br>
                      <span class="text-center text-dark">{{ reportHeadData.address }}</span><br>
                      <div class="titleDiv">
                        <span class="text-center text-dark reportTitle" style="font-weight:bold;">{{ $t('report_management.circular') + ' ' + $t('report_management.publication') + ' ' + $t('globalTrans.report') }}</span><br>
                      </div>
                    </b-col>
                  <b-col xs="12" sm="12" md="3" class="text-left mt-4">
                    <b-img :src="`${ reportHeadData.reportHeadColumn[1].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
                  </b-col>
                    <b-col xs="12" sm="12" md="12" class="mt-4 mb-1">
                        <b-row>
                            <b-col xs="12" sm="12" md="6" class="text-left">
                              <div v-if="search.org_id" class="text-dark"><b>{{ $t('globalTrans.organization') }} </b>: {{ orgName(search.org_id) }}</div>
                              <div v-if="search.training_title_id" class="text-dark"><b>{{ $t('elearning_config.training') }} </b>: {{ trainingName(search.training_title_id) }}</div>
                            </b-col>
                            <b-col xs="12" sm="12" md="6" class="text-right">
                              <span v-if="search.fiscal_year_id" class="text-center text-dark"><b>{{ $t('globalTrans.fiscal_year') }} </b>: {{ fiscalYear(search.fiscal_year_id) }}</span><br/>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col lg="12" sm="12">
                    <b-overlay :show="loadingState">
                        <b-table-simple striped bordered small>
                            <b-tr class="bg-primary">
                              <b-th>{{ $t('globalTrans.sl_no') }}</b-th>
                              <th scope="col">{{ $t('application_management.circular_memo_no') }}</th>
                              <th scope="col">{{ $t('globalTrans.fiscal_year') }}</th>
                              <th scope="col">{{ $t('globalTrans.organization') }}</th>
                              <th scope="col">{{ $t('elearning_config.training')}}</th>
                              <th scope="col">{{ $t('application_management.venue') }} {{ $t('elearning_config.name') }}</th>
                              <th scope="col">{{ $t('application_management.start_date') }}</th>
                              <th scope="col">{{ $t('application_management.end_date') }}</th>
                              <th scope="col">{{ $t('application_management.remarks') }}</th>
                            </b-tr>
                            <b-tr v-for="(item, index) in report_data" :key="index">
                                <b-td>
                                  {{ $n(index + 1) }}
                                </b-td>
                                <b-td>{{ item['circular_memo_no'] }}</b-td>
                                <b-td v-if="item['fiscal_year_id']">{{ fiscalYear(item['fiscal_year_id']) }}</b-td>
                                <b-td v-if="item['org_id']">{{ orgName(item['org_id']) }}</b-td>
                                <b-td v-if="item['training_title_id']">{{ trainingName(item['training_title_id']) }}</b-td>
                                <b-td v-if="item['venue_id']">{{ venueName(item['venue_id']) }}</b-td>
                                <b-td class="text-center">
                                  {{ item['training_start_date'] | dateFormat}}
                                </b-td>
                                <b-td class="text-center">
                                  {{ item['training_end_date'] | dateFormat}}
                                </b-td>
                                <b-td class="text-center">
                                  {{ item['remarks'] }}
                                </b-td>
                            </b-tr>
                            <b-tr v-if="notFound">
                              <b-td colspan="9" align="center"> {{ (currentLocale == 'bn') ? 'তথ্য পাওয়া যায়নি' : 'Data not found' }} </b-td>
                            </b-tr>
                        </b-table-simple>
                    </b-overlay>
                    </b-col>
                </b-row>
            </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import Excel from './export-excel'
import RestApi, { trainingElearningServiceBaseUrl } from '@/config/api_config'
import { circularPublicationReport } from '../../api/routes'
import RouteBasedList from '@/mixins/route-base-list'
import ExportPdf from './export-pdf'
import ReportHeading from '@/Utils/report-head'
import excel from 'vue-excel-export'
import Vue from 'vue'
Vue.use(excel)
export default {
  mixins: [RouteBasedList],
  components: {
  },
  data () {
    return {
      search: {
        fiscal_year_id: 0,
        circular_id: 0,
        training_title_id: 0,
        org_id: 0
      },
      trainingTitleList: [],
      circularMemoList: [],
      report_data: [],
      loaded: false,
      notFound: true,
      reportHeadData: ''
    }
  },
  computed: {
    headerValue: function () {
      const title = this.$t('report_management.circular') + ' ' + this.$t('report_management.publication') + ' ' + this.$t('globalTrans.report')
      return Excel.headerData(this, title)
    },
    excelData: function () {
      return Excel.excelBody(this)
    },
    fiscalYearList: function () {
      return this.$store.state.commonObj.fiscalYearList.map(obj => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
    },
    orgList: function () {
      return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0).map(obj => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
    },
    trainingNameList: function () {
      return this.$store.state.TrainingElearning.commonObj.trainingNameList.filter(item => item.status === 1).map(obj => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
    },
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
    'search.fiscal_year_id': function (newVal, oldVal) {
      this.circularMemoList = this.getMomoList(newVal)
      this.search.circular_id = 0
      this.search.training_name_id = 0
      this.trainingTitleList = []
    },
    'search.circular_id': function (newVal, oldVal) {
      this.trainingTitleList = this.getTrainingTitle(newVal)
    },
    currentLocale: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.headerName()
      }
    }
  },
  created () {
    this.search.org_id = this.$store.state.dataFilters.orgId
    this.headerName()
  },
  mounted () {
  },
  methods: {
    getMomoList (fiscalYearId) {
      return this.$store.state.TrainingElearning.commonObj.circularMemoList.filter(item => item.fiscal_year_id === fiscalYearId).map(item => {
        if (this.$i18n.locale === 'bn') {
          return { value: item.value, text: item.text_bn }
        } else {
          return { value: item.value, text: item.text_en }
        }
      })
    },
    getTrainingTitle (circularMemoId) {
      const trainingObj = this.$store.state.TrainingElearning.commonObj.circularMemoList.find(item => item.value === circularMemoId)
      return this.$store.state.TrainingElearning.commonObj.trainingNameList.filter(item => item.status === 1 && item.value === trainingObj.training_title_id).map(item => {
        if (this.$i18n.locale === 'bn') {
          return { value: item.value, text: item.text_bn }
        } else {
          return { value: item.value, text: item.text_en }
        }
      })
    },
    venueName (venueId) {
      const venueObj = this.$store.state.TrainingElearning.commonObj.venueNameList.find(item => item.value === venueId)
      if (venueObj !== undefined) {
          if (this.$i18n.locale === 'bn') {
              return venueObj.text_bn
          } else {
              return venueObj.text_en
          }
      }
    },
    searchData () {
      this.loadData()
    },
    loadData () {
      const params = Object.assign({}, this.search)
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(trainingElearningServiceBaseUrl, circularPublicationReport, params).then(response => {
          if (response.success) {
            if (response.data !== null) {
              this.report_data = response.data
              if (response.data.length > 0) {
                this.notFound = false
              } else {
                this.notFound = true
              }
              this.$store.dispatch('setList', response.data)
            } else {
              this.report_data = ''
              this.notFound = true
            }
          }
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    async headerName () {
      const headdata = await ReportHeading.getReportHead(trainingElearningServiceBaseUrl, 'config/report-heading/detail', 4)
      this.reportHeadData = headdata
      this.loaded = true
    },
    pdfExport () {
      const reportTitle = this.$t('report_management.circular') + ' ' + this.$t('report_management.publication') + ' ' + this.$t('globalTrans.report')
      ExportPdf.exportPdfDetails(trainingElearningServiceBaseUrl, 'config/report-heading/detail', 4, reportTitle, this.report_data, this, this.search)
    },
    orgName (orgId) {
      const orgName = this.$store.state.commonObj.organizationProfileList.find(item => item.value === orgId)
      if (this.$i18n.locale === 'bn') {
        return orgName.text_bn
      } else {
        return orgName.text_en
      }
    },
    fiscalYear (fiscalYearId) {
      const fiscalYear = this.fiscalYearList.find(item => item.value === fiscalYearId)
      return fiscalYear.text
    },
    trainingName (trainingTitleId) {
      const trainingName = this.$store.state.TrainingElearning.commonObj.trainingNameList.find(item => item.status === 1 && item.value === trainingTitleId)
      if (this.$i18n.locale === 'bn') {
        return trainingName.text_bn
      } else {
        return trainingName.text_en
      }
    }
  }
}
</script>
